"use strict";

var utils;

utils = {};

module.exports = utils;


/*****************
 ** WEBPACK FOOTER
 ** ./lib/utils/utils.js
 ** module id = 585
 ** module chunks = 0
 **/